import { ProjectPlagiarismCheckStatus } from 'content-manager/src/app/core/open-api/content-manager-api-client';
import { buildEnumMapProvider } from 'sc-common';

export const plagiarismCheckStatusEnumMapProvider = buildEnumMapProvider(ProjectPlagiarismCheckStatus, getEnumText, getStatusStyle);

export function getEnumText(value: ProjectPlagiarismCheckStatus): string {

    switch (value) {
        case ProjectPlagiarismCheckStatus.Unchecked:
            return $localize`Unchecked`;
        case ProjectPlagiarismCheckStatus.CreatingSubmissions:
            return $localize`Creating Submissions`;
        case ProjectPlagiarismCheckStatus.PollingSubmissions:
            return $localize`Polling Submissions`;
        case ProjectPlagiarismCheckStatus.GeneratingReports:
            return $localize`Generating Reports`;
        case ProjectPlagiarismCheckStatus.PollingReports:
            return $localize`Polling Reports`;
        case ProjectPlagiarismCheckStatus.Checked:
            return $localize`Checked`;
        case ProjectPlagiarismCheckStatus.Failed:
            return $localize`Failed`;
        case ProjectPlagiarismCheckStatus.FinishedWithErrors:
            return $localize`Finished with Errors`;
    }
}

export function getStatusStyle(status: ProjectPlagiarismCheckStatus): string {
    switch (status) {
        case ProjectPlagiarismCheckStatus.Unchecked:
            return 'success';
        case ProjectPlagiarismCheckStatus.CreatingSubmissions:
            return 'info';
        case ProjectPlagiarismCheckStatus.PollingSubmissions:
            return 'info';
        case ProjectPlagiarismCheckStatus.GeneratingReports:
            return 'info';
        case ProjectPlagiarismCheckStatus.PollingReports:
            return 'info';
        case ProjectPlagiarismCheckStatus.Checked:
            return 'success';
        case ProjectPlagiarismCheckStatus.Failed:
            return 'danger';
        case ProjectPlagiarismCheckStatus.FinishedWithErrors:
            return 'warning';
        default: return '';
    }
}
